module.exports = __webpack_public_path__ + "img/NoDissatisfaction.f1321831.png";